import { render, staticRenderFns } from "./1000MigliaEventDetails.vue?vue&type=template&id=a672f58c&scoped=true"
import script from "./1000MigliaEventDetails.vue?vue&type=script&lang=js"
export * from "./1000MigliaEventDetails.vue?vue&type=script&lang=js"
import style0 from "./1000MigliaEventDetails.vue?vue&type=style&index=0&id=a672f58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a672f58c",
  null
  
)

/* custom blocks */
import block0 from "./1000MigliaEventDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports